import ProfileCard from './ProfileCard';
import QuickLinkCard from './QuickLinkCard';
import QuickLinks from './QuickLinks';
import Slider from './Slider';
export default { ProfileCard: ProfileCard, QuickLinkCard: QuickLinkCard, QuickLinks: QuickLinks, Slider: Slider };
//# sourceMappingURL=index.js.map